import { history, useIntl, useLocation } from '@umijs/max';
import { Grid } from 'antd';
import { createStyles } from 'antd-style';
import React from 'react';
import { UserGlyph } from '@/pages/user/authIcons';

const useStyles = createStyles(({ css, token }) => ({
  bar: css`
    position: fixed;
    inset-inline: 0;
    bottom: 0;
    z-index: 100;
    display: grid;
    grid-template-columns: 1fr 1fr;
    background: ${token.colorBgContainer};
    /* 全面屏手机底部有手势条，留出安全区 */
    padding-bottom: env(safe-area-inset-bottom);
  `,

  tab: css`
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    gap: 3px;
    min-height: 52px;
    border: none;
    background: transparent;
    cursor: pointer;
    font-size: 11px;
    color: ${token.colorTextSecondary};

    svg {
      font-size: 20px;
    }

    &[data-active='true'] {
      color: ${token.colorPrimary};
    }
  `,
}));

/** 九宫格图标：四个小方块。 */
const GridGlyph: React.FC = () => (
  <svg width="20" height="20" viewBox="0 0 16 16" fill="currentColor" aria-hidden="true">
    <path d="M2.5 2.5h4.2v4.2H2.5zM9.3 2.5h4.2v4.2H9.3zM2.5 9.3h4.2v4.2H2.5zM9.3 9.3h4.2v4.2H9.3z" />
  </svg>
);

const TABS = [
  { key: '/my-platforms', icon: <GridGlyph />, id: 'menu.myPlatforms', label: '我的平台' },
  { key: '/me', icon: <UserGlyph size={20} />, id: 'menu.me', label: '我的' },
];

/**
 * 手机端底部导航。
 *
 * 只在窄屏渲染 —— 桌面有左侧菜单，不需要它。登录、注册、授权这些
 * 不在主框架里的页面本来就不会挂到布局上，所以不用额外排除。
 */
export const MobileTabBar: React.FC = () => {
  const { styles } = useStyles();
  const intl = useIntl();
  const location = useLocation();
  const screens = Grid.useBreakpoint();

  if (screens.md) {
    return null;
  }

  return (
    <nav className={styles.bar}>
      {TABS.map((tab) => (
        <button
          type="button"
          key={tab.key}
          className={styles.tab}
          data-active={location.pathname.startsWith(tab.key)}
          onClick={() => history.push(tab.key)}
        >
          {tab.icon}
          {intl.formatMessage({ id: tab.id, defaultMessage: tab.label })}
        </button>
      ))}
    </nav>
  );
};
